module.exports = __webpack_public_path__ + "static/media/narrativescience.5984f5bb.jpg";